export enum CardBrandsEnum {
  VISA = 'visa',
  MASTER_CARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
}
